export enum MessageType {
	Engagement = 'engagement',
	Transactional = 'transactional',
}
